import React, { useEffect, useContext } from "react";
import { Authentication } from "@swegon/sds-core";

export const Login = () => {
    const { login } = useContext(Authentication.AuthContext);

    useEffect(() => {
        login();
    });
    return <></>;
};

export default Login;
